import { render, staticRenderFns } from "./TNCText.vue?vue&type=template&id=30bb4576&scoped=true&"
import script from "./TNCText.vue?vue&type=script&lang=js&"
export * from "./TNCText.vue?vue&type=script&lang=js&"
import style0 from "./TNCText.vue?vue&type=style&index=0&id=30bb4576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb4576",
  null
  
)

export default component.exports